module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery9-8f94e5dcfc05d5a1f9971417a03876a9.jpg";